import { Controller } from "@hotwired/stimulus";

// Drives the API key "Expires" chooser: reveals the date field only for the
// custom choice and echoes what the selection means underneath. Each <option>
// carries its own summary text so dates stay formatted and translated
// server-side.
export default class extends Controller {
  static targets = ["select", "customRow", "customInput", "summary"];
  static values = { customChoice: String };

  connect() {
    this.update();
  }

  update() {
    const isCustom = this.selectTarget.value === this.customChoiceValue;

    this.customRowTarget.classList.toggle("hidden", !isCustom);
    // Disabled inputs are not submitted, so a date left over from an earlier
    // selection can't reach the server once the choice moves off custom.
    this.customInputTarget.disabled = !isCustom;
    this.customInputTarget.required = isCustom;

    this.summaryTarget.textContent =
      this.selectTarget.selectedOptions[0]?.dataset.summary ?? "";
  }
}
